import React from "react";

export const PortfolioCard = ({
  src,
  title,
  shortDescription,
  technology = [],
  Section,
  Url,
  onClick
}) => {
  return (
    <div className="card portfolio-card-clickable" onClick={onClick} style={{ cursor: 'pointer' }}>
      <div className="imag">
   
          <img
            src={src}
            className="card-img-top"
            alt={title}
          />
      </div>

      <div className="card-body">
        <h5 className="card-title text-center">{title}</h5>

        <p
          className="text-center"
          style={{ fontSize: "14px", height: "85px" }}
        >
          {shortDescription}
        </p>

        <div className="tech-Body">
          <div className="techlist">
            {technology.map((tech, index) => (
              <div className="techli" key={index}>
                {tech}
              </div>
            ))}
          </div> 
        </div>     
           
           
       {Section === "REPORTS" && Url != "" &&(   <div className="">
          <div className="techlist">  
         <a href={Url} target="blank" onClick={(e) => e.stopPropagation()}>  <div className="techli" >Open Report</div></a> </div>
        </div>
        ) 
        }   
      </div>
    </div>
  );
};
